import React, { useMemo } from 'react'
import styled from 'styled-components'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import FlashHotelRateOption from '../FlashHotelRateOption'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'

const PackagesContainer = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.six};
`

interface Props {
  offer: App.Offer;
  airports: Array<App.Airport>;
  packageViews: Array<OfferPackageOptionView>;
}

function FlashHotelPackageOptionsModalTab(props: Props) {
  const { offer, airports, packageViews } = props

  const destinationAirport = useMemo(() => airports.find(({ code }) => code === offer.flightDestinationPort), [airports, offer.flightDestinationPort])

  return (
    <PackagesContainer direction="vertical" gap={16}>
      {packageViews.map((view, index) => <Pane key={view.package.uniqueKey}>
        <FlashHotelRateOption
          offer={offer}
          optionNumber={index + 1}
          packageView={view}
          flightDestination={destinationAirport}
        />
      </Pane>)}
    </PackagesContainer>
  )
}

export default withOfferPageAndReduxState((state, appState) => {
  return {
    offer: state.offer,
    airports: appState.geo.airports,
  }
})(FlashHotelPackageOptionsModalTab)
